module.exports = __webpack_public_path__ + "img/active-banner-2022-08-10.36639904.jpg";